<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        :class="isMobile?'mx-auto my-2 card boxStyle' : 'mx-3 my-2 card boxStyle' "
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "designType",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'ساده',
                    value: 'simple',
                    full_path: require('../../../../public/media/site/designType/ساده.png')
                },
                {
                    id: '2',
                    name: 'کلاسیک',
                    value: 'classic',
                    full_path: require('../../../../public/media/site/designType/کلاسیک.png')
                },
                {
                    id: '3',
                    name: 'لوکس',
                    value: 'luxury',
                    full_path: require('../../../../public/media/site/designType/لوکس.png')
                },
                {
                    id: '4',
                    name: 'خلاق',
                    value: 'innovative',
                    full_path: require('../../../../public/media/site/designType/خلاق.png')
                },
                {
                    id: '5',
                    name: 'فانتزی',
                    value: 'fantasy',
                    full_path: require('../../../../public/media/site/designType/فانتزی.png')
                },
                {
                    id: '6',
                    name: 'عمومی',
                    value: 'public',
                    full_path: require('../../../../public/media/site/designType/عمومی.png')
                },
                {
                    id: '7',
                    name: 'اداری/سازمانی',
                    value: 'office',
                    full_path: require('../../../../public/media/site/designType/سازمانی،اداری.png')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"sabksType")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>